import { getRequest, postRequest, getDocumentFetchParameters } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm += getDocumentFetchParameters()
  return getRequest(`document/get-list/999/${index || 0}/${searchTerm || '%20'}/${orderBy || 'CreatedDate ASC'}`)
}

export async function find(id) {
  return getRequest(`document/edit/${id}`)
}

export async function save(values) {
  return postRequest(`document/save`, values)
}

export function remove(values) {
  return postRequest(`document/delete`, values)
}
